const THINKIFIC_ICON_URL =
  'https://cdn.thinkific.com/9/20191030/1cdd7acff5f5489e5339f697a9c89864.svg';

export default THINKIFIC_ICON_URL;
